module.exports = __webpack_public_path__ + "static/media/A2_14.5c2bbc6e.png";